import level1 from './data/level1.json';
import level2 from './data/level2.json';
import level3 from './data/level3.json';
import level4 from './data/level4.json';
import level5 from './data/level5.json';
import level6 from './data/level6.json';
import level7 from './data/level7.json';
import level8 from './data/level8.json';
import level9 from './data/level9.json';
import level10 from './data/level10.json';
import { Brick } from '../entities/Brick';
import { Collectible } from '../entities/Collectible';
import {
  BRICK_TYPES,
  GRID_COLS,
  GRID_ROWS,
  COLLECTIBLE_TYPES,
} from '../core/Constants';

/**
 * Level progression across 10 consecutively harder levels
 */
export class LevelManager {
  constructor() {
    this.levels = [
      level1,
      level2,
      level3,
      level4,
      level5,
      level6,
      level7,
      level8,
      level9,
      level10,
    ];
    this.currentLevelIndex = 0;
    this.currentLevelData = null;
    this.bricks = [];
  }

  getCurrentLevelNumber() {
    return this.currentLevelIndex + 1;
  }

  getTotalLevels() {
    return this.levels.length;
  }

  loadLevel(levelIndex, difficulty) {
    if (levelIndex < 0 || levelIndex >= this.levels.length) {
      levelIndex = 0;
    }
    this.currentLevelIndex = levelIndex;
    this.currentLevelData = this.levels[levelIndex];

    const grid = this.currentLevelData.grid;
    // Consecutively harder silver hit requirement scaling with level progression
    const levelScaling = Math.floor(this.currentLevelIndex / 3);
    const baseSilver = difficulty.silverHits || this.currentLevelData.silverHits || 2;
    const silverHits = Math.min(6, baseSilver + levelScaling);

    this.bricks = [];

    for (let row = 0; row < GRID_ROWS; row++) {
      for (let col = 0; col < GRID_COLS; col++) {
        const type = grid[row] && grid[row][col] !== undefined ? grid[row][col] : 0;
        this.bricks.push(new Brick(col, row, type, silverHits));
      }
    }

    console.log(`Loaded Level ${this.getCurrentLevelNumber()}/10: ${this.currentLevelData.name} (Silver hits: ${silverHits})`);
    return this.bricks;
  }

  resetCurrentLevel(difficulty) {
    return this.loadLevel(this.currentLevelIndex, difficulty);
  }

  hasNextLevel() {
    return this.currentLevelIndex + 1 < this.levels.length;
  }

  nextLevel(difficulty) {
    if (this.hasNextLevel()) {
      return this.loadLevel(this.currentLevelIndex + 1, difficulty);
    }
    return null;
  }

  getRemainingDestructibleCount() {
    return this.bricks.filter(
      (b) => !b.destroyed && b.type !== BRICK_TYPES.EMPTY && !b.isGold && b.type !== BRICK_TYPES.BLACK_WALL
    ).length;
  }

  /**
   * Decide whether to spawn a power-up capsule on brick destruction
   * Drop rates taper slightly on higher levels to enhance challenge
   */
  rollCollectible(brick, difficulty) {
    const levelDampener = Math.max(0.65, 1.0 - this.currentLevelIndex * 0.03);
    const dropRate = difficulty.dropRate * levelDampener;
    const roll = Math.random();
    if (roll > dropRate) {
      return null;
    }

    const weights = [
      { type: COLLECTIBLE_TYPES.EXPAND, weight: 25 },
      { type: COLLECTIBLE_TYPES.SLOW, weight: 20 },
      { type: COLLECTIBLE_TYPES.CATCH, weight: 15 },
      { type: COLLECTIBLE_TYPES.LASER, weight: 15 },
      { type: COLLECTIBLE_TYPES.DISRUPT, weight: 15 },
      { type: COLLECTIBLE_TYPES.PLAYER, weight: 5 },
      { type: COLLECTIBLE_TYPES.BREAK, weight: 5 },
    ];

    const totalWeight = weights.reduce((sum, item) => sum + item.weight, 0);
    let rand = Math.random() * totalWeight;
    let selectedType = COLLECTIBLE_TYPES.EXPAND;

    for (const item of weights) {
      if (rand < item.weight) {
        selectedType = item.type;
        break;
      }
      rand -= item.weight;
    }

    const spawnX = brick.x + brick.width / 2;
    const spawnY = brick.y + brick.height / 2;
    return new Collectible(spawnX, spawnY, selectedType);
  }
}
